import type { AlgorithmType } from "../redistribution/models/AlgorithmType.js";
import type { DemandSourceType } from "../redistribution/models/DemandSourceType.ts";
import type { PurchaseOrder } from "../redistribution/models/PurchaseOrder.js";
import {
  redistributeSkus,
  type RedistributionSubmission,
} from "./apiClient.ts";
import type { SkuForecastsResult } from "./purchaseOrderService.ts";

export async function runRedistribution(
  purchaseOrders: PurchaseOrder[],
  rateOfSaleDays: number,
  poCube: number,
  algorithm: AlgorithmType = "BruteForce",
  allowedReasons?: string[],
  avgDaysOfStockBySku?: SkuForecastsResult,
  demandSource?: DemandSourceType
): Promise<RedistributionSubmission> {
  return redistributeSkus(
    purchaseOrders,
    rateOfSaleDays,
    poCube,
    algorithm,
    allowedReasons,
    avgDaysOfStockBySku,
    demandSource
  );
}
